<template>
  <div :id="`modal-${modalId}`">
    <MadModal
      :id="modalId"
      :data-cy="`${modalId}-modal`"
      :options="options"
      @opened="onOpened"
      @closed="onClosed"
    >
      <div class="modal-body">
        <b-tabs
          v-model="tabIndex"
          no-key-nav
        >
          <template>
            <b-tab :title="`${this.$i18n.t('JSON.channels')}`">
              <div class="v-table">
                <TableServer type="channels" />
              </div>
            </b-tab>
            <b-tab :title="`${this.$i18n.t('JSON.add-channel')}`">
              <ChannelForm v-if="fetcherAdminSchemas.forms['Channel']" />
            </b-tab>
            <b-tab
              v-if="channelId !== null && fetcherAdminChannel.cid !== ''"
              :title="`${this.$i18n.t('JSON.channel')}#${channelId}`"
            >
              <!-- <ChannelForm -->
              <!-- v-if="fetcherAdminSchemas.forms['Channel']" -->
              <!-- :channel="fetcherAdminChannel" -->
              <!-- mode="edit" -->
              <!-- /> -->

              <Debug
                :expanded="true"
                :force-show="true"
                :label="`${this.$i18n.t('JSON.channel')}#${channelId}`"
                :data="fetcherAdminChannel"
              />
            </b-tab>
          </template>
        </b-tabs>
      </div>
    </MadModal>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

import formHelpers from '@/mixins/admin/helpers/form-helpers';
import modalHelpers from '@/mixins/admin/helpers/modal-helpers';

export default {
  components: {
    MadModal: () => import('@/components/MadModal'),
    ChannelForm: () => import('@/components/admin/fetcher/modals/forms/ChannelForm'),
  },

  mixins: [
    formHelpers, //
    modalHelpers,
  ],

  props: {
    channelId: {
      type: String,
      default: () => '',
    },
  },

  data() {
    return {
      options: {
        width: '75%',
        //   height: '95%',
      },
    };
  },

  computed: {
    ...mapState({
      fetcherAdminChannel: (state) => state.fetcherAdminChannel.fetcherAdminChannel,
    }),

    modalId() {
      return 'channel';
    },
  },

  watch: {
    channelId(newValue) {
      if (newValue !== null) {
        this.loadFetcherAdminChannel();
      }
    },
  },

  methods: {
    ...mapActions(['getFetcherAdminChannel']),

    async loadFetcherAdminChannel() {
      try {
        await this.getFetcherAdminChannel({
          params: {
            cid: this.channelId,
          },
        });

        // console.log('channel', this.channel);

        // success
        // console.log('success loading channel!');
      } catch (error) {
        // error
        // console.log('error loading channel!');
      }
    },

    onOpened() {
      if (this.channelId !== null) {
        this.loadFetcherAdminChannel();
      }

      this.modalOpened();
    },

    onClosed() {
      this.modalClosed();
    },
  },
};
</script>
